// extracted by mini-css-extract-plugin
module.exports = {"label":"ProTip-module--label--424339","eyesEmoji":"ProTip-module--eyesEmoji--b6ac74"};